import { type ReactNode } from 'react';

export interface ClaudeAssistantPanelProps {
  title: string;
  children: ReactNode;
  pinnedTop?: ReactNode;
  footer?: ReactNode;
  /** Optional element rendered at the right edge of the header bar (e.g. collapse toggle). */
  headerRight?: ReactNode;
}

export function ClaudeAssistantPanel({ title, children, pinnedTop, footer, headerRight }: ClaudeAssistantPanelProps) {
  return (
    <div style={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      background: 'var(--evo-bg)',
    }}>
      <div style={{
        height: 'var(--evo-toolbar-height)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 var(--evo-space-4)',
        borderBottom: '1px solid var(--evo-stroke)',
        flexShrink: 0,
      }}>
        <span style={{
          fontSize: 'var(--evo-fs-caption)',
          fontWeight: 'var(--evo-fw-medium)',
          letterSpacing: 'var(--evo-ls-caps)',
          textTransform: 'uppercase',
          color: 'var(--evo-accent)',
          fontFamily: 'var(--evo-font)',
        }}>
          {title}
        </span>
        {headerRight}
      </div>

      {pinnedTop != null && (
        <div style={{ flexShrink: 0 }}>
          {pinnedTop}
        </div>
      )}

      <div style={{
        flex: 1,
        overflowY: 'auto',
        padding: 'var(--evo-space-4)',
      }}>
        {children}
      </div>

      {footer != null && (
        <div style={{
          flexShrink: 0,
          borderTop: '1px solid var(--evo-stroke)',
          padding: 'var(--evo-space-3) var(--evo-space-4)',
        }}>
          {footer}
        </div>
      )}
    </div>
  );
}
